/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginStatusDto } from '../../models/login-status-dto';

export interface AuthControllerLoginAs$Params {
  id: number;
}

export function authControllerLoginAs(http: HttpClient, rootUrl: string, params: AuthControllerLoginAs$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStatusDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerLoginAs.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginStatusDto>;
    })
  );
}

authControllerLoginAs.PATH = '/api/auth/login-as/{id}';
